/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Experience_Trendmover_SummaryInputs */

const en_experience_trendmover_summary = /** @type {(inputs: Experience_Trendmover_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shipped React Native product features end-to-end with scalable state management and tighter mobile UX.`)
};

const ar_experience_trendmover_summary = /** @type {(inputs: Experience_Trendmover_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أطلقت ميزات React Native كاملة مع إدارة حالة قابلة للتوسع وتجربة جوال محسّنة.`)
};

const bn_experience_trendmover_summary = /** @type {(inputs: Experience_Trendmover_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্কেলযোগ্য স্টেট ম্যানেজমেন্ট ও মজবুত মোবাইল UX দিয়ে React Native প্রোডাক্ট ফিচার এন্ড-টু-এন্ড শিপ করেছি।`)
};

const de_experience_trendmover_summary = /** @type {(inputs: Experience_Trendmover_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das ausgelieferte React Native-Produkt verfügt über umfassende End-to-End-Funktionen mit skalierbarem Zustandsmanagement und einer strafferen mobilen UX.`)
};

const es_experience_trendmover_summary = /** @type {(inputs: Experience_Trendmover_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funciones de producto React Native publicadas de extremo a extremo, con gestión de estado escalable y UX móvil más ajustada.`)
};

const fr_experience_trendmover_summary = /** @type {(inputs: Experience_Trendmover_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonctionnalités produit React Native livrées de bout en bout, avec gestion d'état évolutive et UX mobile resserrée.`)
};

const pt_experience_trendmover_summary = /** @type {(inputs: Experience_Trendmover_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funcionalidades de produto React Native publicadas de ponta a ponta, com gerenciamento de estado escalável e UX mobile mais ajustada.`)
};

const zh_experience_trendmover_summary = /** @type {(inputs: Experience_Trendmover_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`带着可扩展的状态管理和更紧凑的移动端体验，端到端交付 React Native 产品功能。`)
};

const tr_experience_trendmover_summary = /** @type {(inputs: Experience_Trendmover_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ölçeklenebilir durum yönetimi ve daha sıkı mobil UX ile React Native ürün özellikleri uçtan uca çıkarıldı.`)
};

const ru_experience_trendmover_summary = /** @type {(inputs: Experience_Trendmover_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фичи React Native продукта выкачены end-to-end, со масштабируемым стейт-менеджментом и подтянутым мобильным UX.`)
};

const pl_experience_trendmover_summary = /** @type {(inputs: Experience_Trendmover_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tworzenie i wdrażanie ficzerów produktu React Native od początku do końca, ze skalowalnym stanem i lepszym mobile UX.`)
};

/**
* | output |
* | --- |
* | "Shipped React Native product features end-to-end with scalable state management and tighter mobile UX." |
*
* @param {Experience_Trendmover_SummaryInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const experience_trendmover_summary = /** @type {((inputs?: Experience_Trendmover_SummaryInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Experience_Trendmover_SummaryInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_experience_trendmover_summary(inputs)
	if (locale === "bn") return bn_experience_trendmover_summary(inputs)
	if (locale === "de") return de_experience_trendmover_summary(inputs)
	if (locale === "es") return es_experience_trendmover_summary(inputs)
	if (locale === "fr") return fr_experience_trendmover_summary(inputs)
	if (locale === "pt") return pt_experience_trendmover_summary(inputs)
	if (locale === "zh") return zh_experience_trendmover_summary(inputs)
	if (locale === "tr") return tr_experience_trendmover_summary(inputs)
	if (locale === "ru") return ru_experience_trendmover_summary(inputs)
	if (locale === "pl") return pl_experience_trendmover_summary(inputs)
	return en_experience_trendmover_summary(inputs)
});